module.exports = __webpack_public_path__ + "static/media/nav-broker-icon.261557e6.svg";